export var LiveNewsDTO = function (response) {
    if (response) {
        return {
            content: response.content.map(function (x) {
                return x;
            }),
            number: response.number,
            size: response.size,
            totalElements: response.totalElements,
            totalPages: response.totalPages,
        };
    }
    return {};
};
// implements IAllLiveNewsDTO {
//   readonly category: string;
//   readonly customElements: ICustomElementsDTO[];
//   readonly date: string;
//   readonly desc: string;
//   readonly guid: string;
//   readonly timeText: string;
//   readonly title: string;
//   readonly content: ILiveNewsContentDTO[];
//   constructor(params: ILiveNewsParams) {
//     this.category = params.category;
//     this.customElements = params.customElements;
//     this.category = params.category;
//     this.date = params.date;
//     this.desc = params.desc;
//     this.guid = params.guid;
//     this.timeText = params.timeText;
//     this.title = params.title;
//   }
// }
// class LiveNewsMainDTO  implements {
//   readonly number: number;
//   readonly size: number;
//   readonly totalElements: number;
//   readonly totalPages: number;
//   constructor(
//     number: number,
//     size: number,
//     totalElements: number,
//     totalPages: number
//   ) {
//     this.number = number;
//     this.size = size;
//     this.totalElements = totalElements;
//     this.totalPages = totalPages;
//   }
// }
export default LiveNewsDTO;
